import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import './Login.css';

export default function Login() {
  const [kullanici_adi, setKullaniciAdi] = useState('');
  const [sifre, setSifre]               = useState('');
  const [otp, setOtp]                   = useState('');
  const [adim, setAdim]                 = useState<'giris' | 'otp'>('giris');
  const [mesaj, setMesaj]               = useState('');
  const [hata, setHata]                 = useState('');
  const [yukleniyor, setYukleniyor]     = useState(false);
  const [yeniKodGonderiliyor, setYeniKodGonderiliyor] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setHata('');
    setYukleniyor(true);
    try {
      const res = await authApi.login(kullanici_adi, sifre);
      if (res.data.status === 'otp_required') {
        setMesaj(res.data.mesaj);
        setAdim('otp');
      } else {
        localStorage.setItem('token', res.data.access_token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        navigate('/');
      }
    } catch (err: any) {
      setHata(err.response?.data?.detail || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    } finally {
      setYukleniyor(false);
    }
  };

  const handleOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    setHata('');
    setYukleniyor(true);
    try {
      const res = await authApi.verifyOtp(kullanici_adi, otp);
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/');
    } catch (err: any) {
      setHata(err.response?.data?.detail || 'Doğrulama başarısız.');
    } finally {
      setYukleniyor(false);
    }
  };

  const handleGeriDon = () => {
    setAdim('giris');
    setOtp('');
    setHata('');
    setMesaj('');
  };

  const handleYeniKod = async () => {
    setYeniKodGonderiliyor(true);
    setHata('');
    setOtp('');
    try {
      const res = await authApi.login(kullanici_adi, sifre);
      if (res.data.status === 'otp_required') {
        setMesaj(res.data.mesaj + ' (yeni kod gönderildi)');
      }
    } catch (err: any) {
      setHata(err.response?.data?.detail || 'Kod gönderilemedi.');
    } finally {
      setYeniKodGonderiliyor(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-brand">
          <div className="brand-logo">TİGEM</div>
          <div className="brand-subtitle">Tarım İşletmeleri Genel Müdürlüğü</div>
          <div className="brand-desc">Kurumsal Yönetim Bilgi Sistemi</div>
        </div>
        <div className="login-features">
          <div className="feature-item">🏢 17 Tarım İşletmesi</div>
          <div className="feature-item">📊 Merkezi Veri Yönetimi</div>
          <div className="feature-item">📋 Raporlama ve Sorgulama</div>
          <div className="feature-item">🔐 Rol Tabanlı Yetkilendirme</div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-box">
          {adim === 'giris' ? (
            <>
              <div className="login-box-header">
                <h2>Sisteme Giriş</h2>
                <p>Kullanıcı bilgilerinizi giriniz</p>
              </div>
              <form onSubmit={handleLogin}>
                {hata && <div className="alert alert-danger">{hata}</div>}
                <div className="form-group">
                  <label>Kullanıcı Adı</label>
                  <input
                    className="form-control"
                    type="text"
                    value={kullanici_adi}
                    onChange={e => setKullaniciAdi(e.target.value)}
                    placeholder="Kullanıcı adınızı giriniz"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Şifre</label>
                  <input
                    className="form-control"
                    type="password"
                    value={sifre}
                    onChange={e => setSifre(e.target.value)}
                    placeholder="Şifrenizi giriniz"
                    required
                  />
                </div>
                <button className="btn btn-primary login-btn" type="submit" disabled={yukleniyor}>
                  {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
                </button>
              </form>
            </>
          ) : (
            <>
              <div className="login-box-header">
                <h2>E-posta Doğrulama</h2>
                <p style={{ color: '#27ae60', fontSize: 13 }}>{mesaj}</p>
              </div>
              <form onSubmit={handleOtp}>
                {hata && <div className="alert alert-danger">{hata}</div>}
                <div className="form-group">
                  <label>Doğrulama Kodu</label>
                  <input
                    className="form-control"
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]{6}"
                    maxLength={6}
                    value={otp}
                    onChange={e => setOtp(e.target.value.replace(/\D/g, ''))}
                    placeholder="6 haneli kodu giriniz"
                    autoFocus
                    required
                  />
                  <small style={{ color: '#888' }}>Kod 4 saat geçerlidir.</small>
                </div>
                <button className="btn btn-primary login-btn" type="submit" disabled={yukleniyor}>
                  {yukleniyor ? 'Doğrulanıyor...' : 'Doğrula ve Giriş Yap'}
                </button>
                <button
                  type="button"
                  className="btn login-btn"
                  style={{ background: '#eaf2fb', color: '#1a5276', marginTop: 8, border: '1px solid #aed6f1' }}
                  onClick={handleYeniKod}
                  disabled={yeniKodGonderiliyor}
                >
                  {yeniKodGonderiliyor ? 'Gönderiliyor...' : '🔄 Yeni kod gönder'}
                </button>
                <button
                  type="button"
                  className="btn login-btn"
                  style={{ background: 'none', color: '#666', marginTop: 4 }}
                  onClick={handleGeriDon}
                >
                  ← Geri dön
                </button>
              </form>
            </>
          )}
          <div className="login-footer">
            <small>© {new Date().getFullYear()} TİGEM — Tüm hakları saklıdır</small>
          </div>
        </div>
      </div>
    </div>
  );
}
